import { Button, ButtonOutline, Headline, Layout, ProfileCard, ProfileInfo } from "../../components";
import { ProfileController } from "../../controllers";
import { Edit } from "../../../assets";
import PinInput from "react-pin-input";
import { LinearProgress } from "@mui/material";
import { connect } from "react-redux";
import { shebaRegexp } from "../../../core/regexp";
import { Helmet } from "react-helmet-async";

class Profile extends ProfileController {
    componentDidMount() {
        window.scrollTo(0, 0);

    }
    render() {
        const { unEditable , loading,error} = this.state;
        const {userData} = this.props;
        return (
            <Layout title="پروفایل">
                <Helmet>
        <title> پروفایل | بیمه زندگی هامرز</title>
      </Helmet>
                {loading ? 
                <LinearProgress />
                :
                <div className="profile scrollbar">
                    <div className="profile-container border">
                        <ProfileCard email={userData?.email} image={userData?.picture} name={`${userData?.first_name} ${userData?.last_name}`} position={userData?.brag_type} />
                        {/* <div className="hide-mobile profile-contract">
                            <Button onClick={()=>this.getContrant(true)} myStyle="bg-green" title="مشاهده قرار داد (با سربرگ)" />
                            <Button onClick={()=>this.getContrant(false)} myStyle="bg-light-blue" title="مشاهده قرار داد (بدون سربرگ)" />

                        </div> */}
                    </div>
                    {/* <div className="hide-desktop profile-contract">
                        <Button onClick={()=>this.getContrant(true)} myStyle="bg-green" title="مشاهده قرار داد (با سربرگ)" />
                        <Button onClick={()=>this.getContrant(false)} myStyle="bg-light-blue" title="مشاهده قرار داد (بدون سربرگ)" />

                    </div> */}
                    <div className="profile-info-container border">
                        <Headline isBold title=" اطلاعات هویتی" />
                        <ProfileInfo myStyle="col-lg-3 col-sm-6 col-6 mt-3" title="نام و نام خانوادگی" value={`${userData?.first_name || ""}  ${userData?.last_name || ""}`} />
                        <ProfileInfo myStyle="col-lg-3 col-sm-6 col-6" title="کد ملی" value={userData?.national_code} />
                        <ProfileInfo myStyle="col-lg-3 col-sm-6 col-6" title="تاریخ تولد" value={userData?.birth_date} />
                        <ProfileInfo myStyle="col-lg-3 col-sm-6 col-6" title="کد نمایندگی" value={userData?.brag_code} />
                        <ProfileInfo myStyle="col-lg-3 col-sm-6 col-6" title="نام پدر" value={userData?.father_name} />
                        <ProfileInfo myStyle="col-lg-3 col-sm-6 col-6" title="شماره همراه" value={userData?.mobile} />
                        <ProfileInfo myStyle="col-lg-3 col-sm-6 col-6" title="شماره ثابت" value={userData?.phone} />
                        <ProfileInfo myStyle="col-lg-3 col-sm-6 col-6" title="شغل قبلی" value={userData?.pre_job} />
                        <ProfileInfo myStyle="col-lg-3 col-sm-6 col-6" title="شغل فعلی" value={userData?.job} />
                        <ProfileInfo myStyle="col-lg-3 col-sm-6 col-6" title="سابقه کار بیمه" value={`${userData?.insurance_work_experience_duration || ""} سال `} />
                        <ProfileInfo myStyle="col-lg-3 col-sm-6 col-6" title="مدرک تحصیلی" value={userData?.education_degree}/>
                        <ProfileInfo myStyle="col-lg-3 col-sm-6 col-6" title="وضعیت تاهل" value={userData?.is_marrid ? "متاهل" : "مجرد"} />
                        <ProfileInfo myStyle="col-lg-3 col-sm-6 col-6" title="مدرک ICDL" value={userData?.has_icdl_lisence ? "دارم" :"ندارم"} />
                        <ProfileInfo myStyle="col-lg-6 col-md-12" title="آدرس" value={userData?.address}/>
                    </div>
                    <div className="profile-shaba border shaba-desktop">

                        <div className="d-flex ">
                            <div className="title">  شماره شبا :</div>
                            <div className="text-end">
                            <div className="content">
                                <PinInput
                                    length={24}
                                    focus
                                    disabled={unEditable}
                                    
                                    ref={(n) => this.ref=n}
                                    autoSelect={true}
                                    type="custom"
                                    regexCriteria={shebaRegexp}
                                    inputMode="numeric"
                                    initialValue={userData?.sheba_number}
                                    // inputFocusStyle={{ borderColor: "blue" }}
                                    onChange={(value) => this.setShabaNumber(value)}
                                    
                               
                                />
                                <span className="ir">
                                    IR
                                </span>
                            </div>
                            <span className="error-text">
                                {error[0]?.message}
                            </span>
                            </div>
                        </div>
                        {unEditable ?
                            <ButtonOutline  onClick={() => this.setState({unEditable : false})} icon={Edit} title="ویرایش" />
                            : 
                            <Button onClick={() => this.updateSheba()} myStyle="bg-green submit-btn" title="ثبت شماره شبا" />
                        }
                    </div>
                    <div className="profile-shaba border shaba-mobile">
                        <div className="profile-shaba-header ">
                            <div className="title">  شماره شبا :</div>
                            {unEditable ?
                            <ButtonOutline  onClick={() => this.setState({unEditable : false})} icon={Edit} title="ویرایش" />
                            : 
                            <Button onClick={() => this.updateSheba()} myStyle="bg-green submit-btn" title="ثبت شماره شبا" />
                        }
                        </div>
                        <div className="content">
                            <PinInput
                                length={24}
                                focus
                                autoSelect={true}
                                type="custom"
                                regexCriteria={shebaRegexp}
                                inputMode="numeric"
                                disabled={unEditable}
                                    
                                ref={(n) => this.ref=n}
                                initialValue={userData?.sheba_number}
                                // inputFocusStyle={{ borderColor: "blue" }}
                                onChange={(value) => this.setShabaNumber(value)}
                            />
                            <span className="ir">
                                IR
                            </span>
                        </div>
                    </div>

                </div>
                        }
            </Layout>
        )
    }
}


const mapStateToProps = (dispatch:any) => {
    return {
      dispatch,
      userData:dispatch.general.userData,
    }
  };
  
  export default connect(mapStateToProps)(Profile);